module.exports = __webpack_public_path__ + "img/dgjg2250_1.006b4dcd.svg";